import React, { useRef, useState, useEffect } from 'react';
import ReviewCard from './ReviewCard';

const MOCK_REVIEWS = [
  { id: 1, name: 'سارا محمدی', rating: 5, comment: 'بسیار عالی و با کیفیت. دقیقا همونی بود که میخواستم. ممنون از کادولار.', title: 'خرید عالی' },
  { id: 2, name: 'علی رضایی', rating: 5, comment: 'کیفیت چاپ تابلو فوق‌العاده بود. بسته‌بندی هم خیلی محکم و شیک بود.', title: 'پیشنهاد میکنم' },
  { id: 3, name: 'مریم کریمی', rating: 4, comment: 'طرح‌ها خیلی متنوع و جذاب هستن. من برای هدیه تولد گرفتم و دوستم خیلی خوشش اومد.', title: 'هدیه مناسب' },
  { id: 4, name: 'حسین حسینی', rating: 5, comment: 'سرعت ارسال خیلی خوب بود. پشتیبانی هم خیلی با حوصله جواب دادن.', title: 'ارسال سریع' },
  { id: 5, name: 'نازنین زارع', rating: 5, comment: 'واقعا کارتون درسته. تابلوی فرش خیلی زیبا شده. حتما دوباره خرید میکنم.', title: 'کیفیت بی نظیر' },
  { id: 6, name: 'امیر مرادی', rating: 5, comment: 'قیمت‌ها نسبت به کیفیت خیلی مناسبه. من چند جا قیمت گرفتم اینجا بهترین بود.', title: 'قیمت مناسب' },
  { id: 7, name: 'زهرا صادقی', rating: 4, comment: 'همه چیز خوب بود فقط کاش تنوع قاب‌ها بیشتر بشه. ولی در کل راضیم.', title: 'راضی هستم' },
  { id: 8, name: 'محمد نوری', rating: 5, comment: 'برای دکوراسیون منزل خریدم و خیلی جلوه زیبایی به خونه داده. ممنون.', title: 'زیبا و شیک' },
  { id: 9, name: 'لیلا احمدی', rating: 5, comment: 'کیفیت رنگ‌ها توی چاپ عالیه. اصلا مات و بی روح نیست. زنده و شفاف.', title: 'چاپ با کیفیت' },
  { id: 10, name: 'رضا گودرزی', rating: 5, comment: 'بهترین هدیه‌ای بود که میتونستم برای سالگرد ازدواجمون بگیرم. همسرم خیلی سورپرایز شد.', title: 'سورپرایز عالی' },
  { id: 11, name: 'فاطمه موسوی', rating: 4, comment: 'بسته‌بندی خیلی تمیز و مرتب بود. هیچ آسیبی به محصول نرسیده بود.', title: 'بسته بندی خوب' },
  { id: 12, name: 'سعید رحیمی', rating: 5, comment: 'من طرح اختصاصی سفارش دادم و خیلی دقیق و تمیز کار شده بود. دمتون گرم.', title: 'سفارش اختصاصی' },
  { id: 13, name: 'نرگس پناهی', rating: 5, comment: 'برخورد پرسنل عالی. پیگیری سفارش هم خیلی دقیق انجام شد.', title: 'پشتیبانی عالی' },
  { id: 14, name: 'محسن اکبری', rating: 5, comment: 'کیفیت قاب‌ها خیلی خوبه. اصلا لق نیست و خیلی محکم ساخته شده.', title: 'قاب با کیفیت' },
  { id: 15, name: 'سمیرا شمس', rating: 4, comment: 'تنوع محصولاتتون خیلی خوبه آدم راحت میتونه انتخاب کنه.', title: 'تنوع بالا' },
  { id: 16, name: 'آرش کاظمی', rating: 5, comment: 'سفارشم خیلی زودتر از چیزی که فکر میکردم رسید. ممنون از سرعت عملتون.', title: 'تحویل به موقع' },
  { id: 17, name: 'الهام عزیزی', rating: 5, comment: 'ترکیب رنگ و طراحی تابلوها خیلی مدرن و شیکه. به همه پیشنهاد میکنم.', title: 'طراحی مدرن' },
  { id: 18, name: 'بابک منصوری', rating: 5, comment: 'از خریدم کاملا راضیم. همه چی طبق توضیحات سایت بود.', title: 'صادقانه' },
  { id: 19, name: 'نگار جمشیدی', rating: 5, comment: 'برای اتاق کودکم سفارش دادم و خیلی بامزه و قشنگ شد. ممنون از کادولار.', title: 'اتاق کودک' },
  { id: 20, name: 'کیوان رستمی', rating: 4, comment: 'تجربه خرید خوبی بود. سایت کاربری راحتی داره و مراحل سفارش ساده بود.', title: 'تجربه کاربری خوب' },
];

const DesktopTestimonials = () => {
  const scrollRef = useRef(null);
  const [reviews, setReviews] = useState(MOCK_REVIEWS);

  useEffect(() => {
    // Shuffle mock reviews on mount
    const shuffled = [...MOCK_REVIEWS].sort(() => 0.5 - Math.random());
    setReviews(shuffled);
  }, []);

  const formatFaNumber = (value) => {
    return new Intl.NumberFormat('fa-IR').format(value);
  };

  return (
    <div className="mb-16 relative group px-4">
      <div className="flex items-center justify-between mb-8 border-r-4 border-kadolar-600 pr-4">
        <h2 className="text-2xl font-bold text-gray-900">نظرات مشتریان</h2>
        <div className="flex items-center gap-2 text-gray-500 text-sm">
            <span>نمونه دیدگاه‌های مشتریان</span>
        </div>
      </div>

      <div className="relative">
        <div 
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-6 pt-2 px-4 scrollbar-hide snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {reviews.map((review) => (
            <ReviewCard
              key={review.id}
              name={review.name}
              headline={review.title}
              rating={review.rating}
              comment={review.comment}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopTestimonials;
